import React from 'react';
export const ArbeitsweisePage: React.FC = () => {
  return <section className="w-full bg-white py-16 px-6 md:px-12 lg:px-20" data-id="element-156">
      <div className="max-w-6xl mx-auto" data-id="element-157">
        <div className="flex justify-between items-start mb-12" data-id="element-158">
          <div data-id="element-159">
            <h1 className="text-3xl md:text-4xl text-orange-500 font-light mb-8" data-id="element-160">
              Meine Arbeitsweise
            </h1>

            <h2 className="text-2xl md:text-3xl text-gray-700 font-light" data-id="element-161">
              Inspirierend. Klar. Wertschätzend.
            </h2>
          </div>

          <div className="hidden md:block" data-id="element-162">
            <img src="https://cdn.magicpatterns.com/uploads/oENrfKHxtwwBDD16NEG4or/Eva-Schifferer-Coaching-meine_Arbeitsweise.png" alt="Arbeitsweise Illustration" className="max-w-xs" data-id="element-163" />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-0" data-id="element-164">
          {/* Klar sehen - Orange */}
          <div className="bg-orange-500 text-white p-8 md:p-12" data-id="element-165">
            <h3 className="text-2xl font-light mb-6" data-id="element-166">Klar sehen</h3>
            <p className="text-base leading-relaxed" data-id="element-167">
              Mit Klartext und einem sicheren Gespür für das Wesentliche bringe
              ich die Dinge auf den Punkt. Im Dialog reduzieren wir Komplexität
              und es entsteht Klarheit über Chancen, Risiken und
              Handlungsoptionen.
            </p>
          </div>

          {/* Ehrlich sein - Grau */}
          <div className="text-white p-8 md:p-12" style={{
          backgroundColor: '#545454'
        }} data-id="element-168">
            <h3 className="text-2xl font-light mb-6" data-id="element-169">Ehrlich sein</h3>
            <p className="text-base leading-relaxed" data-id="element-170">
              Wertschätzung und Empathie ergänzt um ehrliches und mutiges
              Feedback, das es im Alltag oft so nicht gibt. Beides
              auszubalancieren ist für mich eine Kunst, die über die jahrelange
              Beratungsarbeit gewachsen ist.
            </p>
          </div>

          {/* Inspirierend denken - Grau */}
          <div className="text-white p-8 md:p-12" style={{
          backgroundColor: '#545454'
        }} data-id="element-171">
            <h3 className="text-2xl font-light mb-6" data-id="element-172">Inspirierend denken</h3>
            <p className="text-base leading-relaxed" data-id="element-173">
              Wenn es sinnvoll ist, gehen wir den Dingen auf den Grund, um
              verborgene Muster offen zu legen. Mit dem Blick nach vorne
              entstehen im Dialog inspirierende Lösungen und ein Umsetzungsplan,
              der der Realität standhält.
            </p>
          </div>

          {/* Pragmatisch vorgehen - Orange */}
          <div className="bg-orange-500 text-white p-8 md:p-12" data-id="element-174">
            <h3 className="text-2xl font-light mb-6" data-id="element-175">Pragmatisch vorgehen</h3>
            <p className="text-base leading-relaxed" data-id="element-176">
              Durch meine Erfahrungen als HR-Manager in internationalen
              Organisationen und als Beraterin bin ich gut vernetzt und
              fokussiere mich in einem pragmatischen Ansatz auf Ihre wichtigsten
              Ziele.
            </p>
          </div>
        </div>
      </div>
    </section>;
};